export interface ResolveMyAccountTargetInput {
  /** `ctx.user?.id` from the user machine. */
  loggedInUserId: string | undefined;
  /** `ctx.user?.defaultAccount?.defaultOrgId` from the user machine. */
  loggedInUserDefaultOrgId: string | undefined;
}

export type MyAccountTarget =
  | { ready: true; orgId: string; userId: string }
  | { ready: false };

/**
 * Resolve which (org, user) pair the standalone My Account surface loads.
 *
 * Both ids come from the user machine, and the `org_id` in the URL is
 * deliberately NOT one of the inputs. Before PSTUDIO-4095 the route was a
 * `<Navigate to={/organization/${loggedInUserOrgId}/users/${loggedInUserId}}>`,
 * which rewrote the org to the user's own on every entry — so the org segment
 * never reached the data layer. Honouring it now would change two things at
 * once: the Roles table would render the tree of whatever org is being viewed
 * (`getAccountDetails({ id: event.orgId })` in the `loadUserDetails` invoke)
 * rather than the user's home org, and a hand-typed org id would reach that
 * query unchecked. Neither is part of splitting the surface out.
 *
 * `orgId` is needed at all because `manager.loadUserDetails` fetches that org
 * tree, not only the user record.
 */
export const resolveMyAccountTarget = ({
  loggedInUserId,
  loggedInUserDefaultOrgId,
}: ResolveMyAccountTargetInput): MyAccountTarget =>
  loggedInUserId && loggedInUserDefaultOrgId
    ? { ready: true, orgId: loggedInUserDefaultOrgId, userId: loggedInUserId }
    : { ready: false };
